import React from 'react';
import { match, Redirect } from 'react-router-dom';

import { getGameModule } from './game-registry';
import GameProvider from './GameProvider';

interface GameRouteArgs {
  match: match<{ type: string; id: string }>;
}

const GameRoute: React.FC<GameRouteArgs> = ({ match }: GameRouteArgs) => {
  const { type, id } = match.params;
  const gameModule = getGameModule(type);

  if (!gameModule) {
    return <Redirect to={{ pathname: '/' }} />;
  }

  const Root = gameModule.Root;
  return (
    <GameProvider module={gameModule}>
      <Root lookup={id} />
    </GameProvider>
  );
};

export default GameRoute;
